import { Component, OnInit, Output, EventEmitter, Input, ViewChild, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-feature-package-evaluation.service';
import { SopDetail } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/Models/SopDetail';
import { PhBhpConsumptionFilterComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-consumption-filter/ph-bhp-consumption-filter.component';
import { PhBhpConsumptionChartExportComponent } from '../ph-bhp-consumption-chart-export/ph-bhp-consumption-chart-export.component';
import { PhBhpConsumptionPdfComplianceComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-consumption-pdf-compliance/ph-bhp-consumption-pdf-compliance.component';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { Location } from '@angular/common';
import { AppConfig } from 'src/app/app.config';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageConsumptionService } from 'src/app/Consumption/ph-bhp-feature-package-consumption.service';
import { TranslationKeys } from 'ph-bhp-localization';
import { Router } from '@angular/router';
import { PhBhpBarChartComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-bar-chart/ph-bhp-bar-chart.component';
import cloneDeep from 'lodash/cloneDeep';

const MAX_DECIMALS: number = 4;

@Component({
    selector: 'lib-ph-bhp-consumptions-patient',
    templateUrl: './ph-bhp-consumptions-patient.component.html',
    styleUrls: ['./ph-bhp-consumptions-patient.component.css']
})
export class PhBhpConsumptionsPatientComponent implements OnInit, OnDestroy {
    translationKeys: typeof TranslationKeys = TranslationKeys;
    benchMark2Txt: string;
    benchMark2AllDept: string;
    benchMark1Txt: string;
    benchMark1AllDept: string;
    filter1Txt: string;
    filter2Txt: string;
    filter1AllDept: string;
    filter2AllDept: string;
    filter1Text: string;
    filter2Text: string;
    benchMarkText: string;
    benchMark1Text: string;
    benchMark2Text: string;
    filter1BenchMark: string;
    filter2BenchMark: string;
    filter1Colon: string;
    filter2Colon: string;
    usedDetailsLtr: string;
    patientDaysTxt: string;
    textLegendTxt: string;
    haiOccurrencesTxt: string;

    subscription: Subscription;
    compareCard;
    showCompareCard;
    singleCard;
    tempFilter;
    @ViewChild('compliance', { static: true }) compliance: PhBhpConsumptionPdfComplianceComponent;
    @ViewChild('multiselect', { static: true }) multiselect: any;
    @Input() filterDetails = [];
    initFlag = true;
    item: any;
    subStepAnotherArra: Array<any> = [];
    sopDetail: SopDetail[];
    sopiDs = "";
    stepTypes = 0;
    defaultTitle;
    noDataFound: boolean = false;
    gridData: Array<any>;
    isCallFor
    userData;
    userSubscription: Subscription;
    @Input() isDesktop = true;
    isAdjustableHeight = true;
    @Output() childData = new EventEmitter();

    public clickImageBtn = false;
    public clickExcelBtn = false;
    public clickPdfBtn = false;

    showPercentageLabel = false;
    private static readonly INITIAL_FIELDS: Array<any> = [
        {
            'field': 'name',
            'title': 'CONFIGURE.PERIOD_1'
        }
    ];
    @ViewChildren(PhBhpBarChartComponent) charts: QueryList<PhBhpBarChartComponent>;
    pageInfo = {
        ofLabel: 'GENERAL.OF',
        items: 'CONFIGURE.CONSUMPTION',
        itemsPerPageLabel: 'CONFIGURE.CONSUMPTION_PER_PAGE'
    };
    dataMonth = [
        "CONSUMPTION.JANUARY",
        "CONSUMPTION.FEBRUARY",
        "CONSUMPTION.MARCH",
        "CONSUMPTION.APRIL",
        "CONSUMPTION.MAY",
        "CONSUMPTION.JUNE",
        "CONSUMPTION.JULY",
        "CONSUMPTION.AUGUST",
        "CONSUMPTION.SEPTEMBER",
        "CONSUMPTION.OCTOBER",
        "CONSUMPTION.NOVEMBER",
        "CONSUMPTION.DECEMBER"
    ];

    periodNames;
    // dataQuarter = ["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"]

    consumptionConfigs;

    tabletitle1
    tabletitle2
    tabletitle3
    tabletitle4
    tabletitle5
    tabletitle6
    userID
    data
    isSavedFromEvaluation: boolean;
    percentageLegend
    // textLegend = "in Liters";
    complianceType;
    haiEnabled = false;
    roleId: any;
    specificStep: Array<any> = [];
    selectedSpecificStep: Array<any> = [];
    @ViewChild('exportTag') export: PhBhpConsumptionChartExportComponent;
    calculatedThreshold: number = 10;
    pageTitle: string;
    appName = 'consumptionPatient';
    isEvaluationTable: boolean = true;
    isUserFilterSetted: boolean = false;
    userHasFilter: boolean = false;

    multiSelectText: string = '';
    results: any = [];
    userFilters: any;
    sopFilters: any[] = [];
    langSubscription: Subscription;
    institutionSubscription: Subscription;
    filterIndices: number[] = [0];
    @ViewChildren(PhBhpConsumptionFilterComponent) filters: QueryList<PhBhpConsumptionFilterComponent>;
    evaluationLoaded: boolean = false;

    constructor(
        public appConfig: AppConfig,
        private evaluationService: PHBHPFeaturePackageEvaluationService,
        private layoutService: PHBHPLayoutPackageService,
        private router: Router
    ) {
        this.pageTitle = this.layoutService.translateText('EVALUATION.CONSUMPTION.CONSUMPTION_PER_PATIENT_TITLE');
        this.textLegendTxt = this.layoutService.translateText(this.translationKeys.Dashboard.inLiters);
        this.userData = this.appConfig.userData;
    }

    ngOnDestroy() {
        if (this.langSubscription)
            this.langSubscription.unsubscribe();
        if (this.institutionSubscription)
            this.institutionSubscription.unsubscribe();
    }

    ngOnInit(): void {
        this.userID = this.appConfig.userData.userId;
        this.roleId = this.appConfig.userData.roleName.roleId;
        this.langSubscription = this.layoutService.lang.asObservable().subscribe((changelang) => {
            setTimeout(() => {
                for (let i = 0; i < this.charts.length; i++) {
                    let chart = this.charts.get(i);
                    chart.chartOptions.valueAxis.title.text = this.textLegendTxt;
                }
                this.pageTitle = this.layoutService.translateText('EVALUATION.CONSUMPTION.CONSUMPTION_PER_PATIENT_TITLE');
                this.compliance.complianceTitle = this.layoutService.translateText('EVALUATION.CONSUMPTION.CONSUMPTION_PER_PATIENT_TITLE');
                this.evaluate(true);
                this.layoutService.showLoader = false;
            }, 1000);
        });

        this.ngOnChanges();
    }

    ngOnChanges() {
        this.layoutService.showLoader = true;
        this.userHasFilter = false;
        if (!this.isUserFilterSetted) {
            this.evaluationService.getUserHasSOPEvaluationFilter(this.userData.userId, 'consumptionPatient').subscribe((userHasFilter) => {
                this.isUserFilterSetted = true;
                if (userHasFilter) {
                    this.userHasFilter = true;
                    this.userFilters = JSON.parse(userHasFilter.filterList);
                    this.userFilters = this.userFilters.ConsumptionFilterList;
                    setTimeout(() => { this.initComponent(); });
                } else {
                    this.userFilters = [];
                    this.noDataFound = true;
                    this.filters.get(0).showFilter(true);
                    // this.compliance.resultsLoader.next([{}]);
                }
            }, (error) => { }, () => { this.layoutService.showLoader = false; });
        } else {
            setTimeout(() => { this.initComponent(); });
        }
    }

    initComponent() {

        if (this.userFilters.length > 0) {
            this.userFilters.forEach((filter, idx) => {
                if (!filter.filterName || filter.filterName.trim() === "") {
                    filter.filterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (idx + 1);
                }
            });
            this.filterIndices = this.userFilters.map((_, index) => index);
            this.showCompareCard = this.filterIndices.length > 1;
        }


        if (this.userData) {
            for (let i = 0; i < this.charts.length; i++) {
                let chart = this.charts.get(i);
                chart.chartOptions.valueAxis.labels = {
                    format: this.percentageLegend
                };
                chart.chartOptions.valueAxis.title.text = this.textLegendTxt;
                
            }

            // this.compliance.printChart = true;
            this.compliance.showFilter = true;
            this.compliance.complianceTitle = this.pageTitle;
            this.compliance.roleId = this.roleId;
            //   this.compliance.fillWith = 'N/A';

            this.loadFiltersInfo();

            if (this.userFilters && this.userFilters.length >= 2 && this.isDesktop) {
                this.showCompareCard = this.filterIndices.length > 1;
                this.compliance.showCompareCard = this.showCompareCard;
                this.tempFilter = this.userFilters;
            }

            this.evaluate(true, true);

        }
    }

    evaluate(getResults, iniatilize?) {
        this.data = {
            consumptionFilterList: [],
            roleId: this.roleId
        };
        if (iniatilize) {
            this.data.consumptionFilterList = this.userFilters;
        } else {
            this.filters.forEach((filter) => {
                let filterData: any = {
                    Year: filter.setyear,
                    InstitutionIds: "",
                    DepartmentId: 0,
                    DepartmentTypeId: 0,
                    WardId: 0,
                    CountryId: 0
                };
                if (this.roleId == 1 && filter.setCountry != 0) {
                    filterData.countryID = filter.setCountry.countryID
                }

                filterData = filter.assignData(filterData);
                this.data.consumptionFilterList.push(filterData);
                if (filterData.multiSelectName) {
                    this.multiSelectText = filterData.multiSelectName;
                }
            });
        }

        this.userHasFilter = true;
        if (getResults == true) {
            this.getConsumptionFilterDetails(this.userData.userId, this.data);
        } else if (getResults == false) {
            this.saveConsumptionFilterDetails(this.userData.userId, this.data);
        }
    }

    filterCompare() {
        if (!this.userHasFilter) {
            this.filters.get(0).showFilter(true);
            return;
        }

        this.compareCard = false;

        if (this.filterIndices.length < 2) {
            this.filterIndices.push(this.filterIndices.length);
        }

        this.showCompareCard = this.filterIndices.length > 1;
        this.compliance.showCompareCard = this.showCompareCard;
        this.layoutService.showLoader = true;
        setTimeout(() => {
            var filters = this.filters.toArray();
            filters[filters.length - 1].setInfoFromFilter(cloneDeep(filters[filters.length - 2]));
            this.layoutService.showLoader = false;
        }, 500);
    }

    async loadFiltersInfo() {
        // need wait for the filter component to be initialized
        setTimeout(() => {
            this.userFilters.forEach((filter, index) => {
                let filterComponent = this.filters.toArray()[index];
                filterComponent.setyear = filter.Year;
                if (this.roleId == 1) {
                    filterComponent.setSAFilter(filter, true);
                } else {
                    filterComponent.setFilterNameFilter(filter.filterName, true);
                    filterComponent.setCountryFilter(filter.CountryId, '', '', true);
                    filterComponent.setInstitutionsByID(filter.InstitutionIds, true);
                    if (filterComponent.wardListLoaded && filterComponent.wardListLoaded.length > 0) {
                        filterComponent.onWardChange(filterComponent.wardListLoaded.find(ward => ward.wardID == filter.WardId));
                    }

                    filterComponent.setDepartmentFilter(filter.DepartmentId, true);
                    filterComponent.setDepartmentTypeFilter(filter.DepartmentTypeId, true);
                    if (filter.Multiselect) {
                        filterComponent.setMultiFilter(filter.Multiselect, filter.MultiSelectFilter, filter.MultiSelectValues, true);
                    }
                }

            });
        }, 500);
    }

    showFilter(cardType) {
        let showFilter = cardType;
        if (showFilter == 'singleCard') {
            this.singleCard = !this.singleCard;
            this.compareCard = false;
        }
        if (showFilter == 'compareCard') {
            this.compareCard = !this.compareCard
            this.singleCard = false;
        }
    }

    getConsumptionFilterDetails(userID, data) {
        this.complianceType = "consumptionPatient";
        this.isSavedFromEvaluation = true;
        this.isCallFor = "empty";
        this.layoutService.showLoader = true;
        data.userId = userID;
        this.evaluationService.getConsumptionPatientDetailsMulti(userID, this.isSavedFromEvaluation, this.isCallFor, data).subscribe(res => {
            this.buildChart(res);
        })
    }

    saveConsumptionFilterDetails(userID, data) {
        this.complianceType = "consumptionPatient";
        this.isSavedFromEvaluation = false;
        this.layoutService.showLoader = true;
        this.evaluationService.getConsumptionPatientDetailsMulti(userID, this.isSavedFromEvaluation, this.complianceType, data).subscribe(res => {
            this.layoutService.showLoader = false;
            this.layoutService.showSuccess(this.layoutService.translateText("EVALUATION.SUCCESSFULLY_SAVED_SUMMARISED_REPORT"));
        })
    }

    ngAfterViewChecked() {
        if (this.tempFilter) {
            let tempFilter = this.tempFilter;
            this.tempFilter = undefined;
            this.userFilters.forEach((filter, index) => {
                let filterComponent = this.filters.toArray()[index];
                let startDate = new Date(filter.startDate);
                filterComponent.setYear(startDate.getUTCFullYear());
                if (this.roleId == 1) {
                    filterComponent.setSAFilter(filter, true);
                } else {
                    filterComponent.setCountryFilter(filter.CountryID, '', '', true);
                    filterComponent.setInstitutionsByID(filter.instutionIDs, true);
                    filterComponent.setDepartmentFilter(filter.departmentID, true);
                    filterComponent.setDepartmentTypeFilter(filter.departmentTypeID, true);
                    if (filter.multiselect) {
                        filterComponent.setMultiFilter(filter.multiselect, filter.multiSelectFilter, filter.multiSelectValues, true);
                    }
                }
            });
        }
    }

    shouldHideBenchmarkDataByResponse(complianceList) {
        // If there is any response isBenchmark: true, then we should show benchmark data
        return complianceList.some(item => item.isBenchmark);
    }

    shouldHideBenchmarkData() {
        return this.anyWardIsSelected();
    }

    anyWardIsSelected() {
        for (let filterComponent of this.filters.toArray()) {
            if (filterComponent.isWardSelected()) {
                return true;
            }
        }
        return false;
    }

    buildChart(res) {
        this.evaluationLoaded = false;
        var colors = [];
        if (!this.shouldHideBenchmarkDataByResponse(res) || this.shouldHideBenchmarkData()) {
            colors = [
                "#001689", "#40C4FF", "#9744FF", "#BF44B9", "#E57373", "#FFB300"
            ];
        } else {
            colors = [
                "#001689", "url(#benchmark1)", "#40C4FF", "url(#benchmark2)", "#9744FF", "url(#benchmark3)", "#BF44B9", "url(#benchmark4)", "#E57373", "url(#benchmark5)", "#FFB300", "url(#benchmark6)"
            ];
        }

        this.results = res;
        let chart: PhBhpBarChartComponent;
        let chartPdf: PhBhpBarChartComponent;
        this.results = [];
        res.forEach(result => {
            if (result.consumptionList.length > 0) {
                let id = result.filterType || 'single';
                if (this.results.findIndex(r => r.id === id) === -1) {
                    this.results.push({
                        id,
                        consumptionList: [],
                        gridData: [],
                        fields: [...PhBhpConsumptionsPatientComponent.INITIAL_FIELDS],
                        benchmarkFields: [...PhBhpConsumptionsPatientComponent.INITIAL_FIELDS],
                        noDataFound: false
                    });
                }
            }
        });

        // The timeout is necessary to give the chart QueryList time to load the component
        setTimeout(() => {
            let filterCount: number = 0;
            let benchmarkCount: number = 0;
            let filterTableCount: number = 0;
            let benchmarkTableCount: number = 0;
            res.forEach((consumptionsArray: any, index) => {
                let chartId = consumptionsArray.filterType || 'single';
                let chartIndex = this.results.findIndex(r => r.id === chartId);
                chart = this.charts.get(chartIndex);
                // chartPdf = this.compliance.charts.get(chartIndex);
                let data = JSON.parse(JSON.stringify(chart.chartOptions));
                // Initialize only first iteration of the chart
                if (!data.setId) {
                    data.nextIndex = 0;
                    data.categoryAxis.categories = [];
                    data.categoryAxis.categoryOffset = [];
                    data.series = [];
                    data.seriesIdentifier = [];
                }

                data.series[data.nextIndex] = { data: [], name: [], dataOffset: [], serieIndex: index };
                data.series[data.nextIndex].color = colors[index];
                data.seriesIdentifier[data.nextIndex] = [];
                chart.chartId = chartId;

                if (consumptionsArray.isBenchmark === false) {
                    if (consumptionsArray.consumptionList.length === 1 && consumptionsArray.consumptionList[0].list.length === 0 && chart.noDataFound) {
                        this.noDataFound = true;
                        chart.noDataFound = true;
                    } else {
                        this.results[chartIndex].noDataFound = false;
                        this.noDataFound = false;
                        chart.noDataFound = false;
                    }
                } else {
                    if (consumptionsArray.consumptionList.length === 2 && consumptionsArray.consumptionList[0].list.length === 0 && chart.noDataFound) {
                        this.noDataFound = true;
                        chart.noDataFound = true;
                    } else {
                        this.results[chartIndex].noDataFound = false;
                        this.noDataFound = false;
                        chart.noDataFound = false;
                    }
                }

                consumptionsArray.consumptionList.forEach((consumption) => {
                    let consumptionItem = consumption;
                    data.series[data.nextIndex].dataSetId = consumptionItem.id;
                    consumption.list.forEach((item) => {
                        data.series[data.nextIndex].data.push(item.consumptionsPatientDay === -1 ? "NODATA" : item.consumptionsPatientDay.toFixed(MAX_DECIMALS));
                        data.series[data.nextIndex].dataOffset.push({ id: 'CONFIGURE.YEAR', setId: consumptionItem.id, value: item.consumptionsPatientDay === -1 ? "NODATA" : item.consumptionsPatientDay.toFixed(MAX_DECIMALS) });
                        data.seriesIdentifier[data.nextIndex].push({ id: 'CONFIGURE.YEAR', setId: consumptionItem.id });
                        let title = this.layoutService.translateText(this.layoutService.translateText('CONFIGURE.YEAR'));
                        if (consumptionItem.id >= 0 && consumptionItem.name) {
                            title += " / " + this.layoutService.translateText(consumptionItem.name);
                        }
                        title = title ? title : 'CONFIGURE.YEAR';
                        if (!data.categoryAxis.categories.includes(title)) {
                            data.categoryAxis.categories.push(title);
                            data.categoryAxis.categoryOffset.push({ id: 'CONFIGURE.YEAR', setId: consumptionItem.id });
                        }
                    });
                });

                let maxLength = data.categoryAxis.categoryOffset.length
                const combinedData = data.series.map(() => new Array(maxLength).fill(null));

                data.series.forEach((item, serieIndex) => {
                    item.dataOffset.forEach((value, index) => {
                        let indexOffset = data.categoryAxis.categoryOffset.findIndex(offset => offset.id === value.id && offset.setId === value.setId);
                        combinedData[serieIndex][indexOffset] = value.value;
                    });
                });

                for (let i = 0; i < combinedData.length; i++) {
                    data.series[i].data = combinedData[i];
                }

                if (consumptionsArray.isBenchmark) {
                    if (this.shouldHideBenchmarkData()) {
                        return;
                    }
                    benchmarkCount++;
                    const benchmarkName = `${this.data.consumptionFilterList && this.data.consumptionFilterList[benchmarkCount-1] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.consumptionFilterList[benchmarkCount-1].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkCount)}`
                    data.series[data.nextIndex].name = [benchmarkName];
                    data.series[data.nextIndex].filterName = [benchmarkName];
                    data.series[data.nextIndex].filterNum = benchmarkCount;
                } else {
                    filterCount++;
                    data.series[data.nextIndex].name = [`${this.data.consumptionFilterList && this.data.consumptionFilterList[filterCount - 1] ? this.data.consumptionFilterList[filterCount - 1].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (filterCount)}`];
                    data.series[data.nextIndex].filterName = [`${this.data.consumptionFilterList && this.data.consumptionFilterList[filterCount - 1] ? this.data.consumptionFilterList[filterCount - 1].filterName : this.layoutService.translate.instant('EVALUATION.FILTER') + ' ' + (filterCount)}`];
                    data.series[data.nextIndex].filterNum = filterCount
                }

                data.categoryAxis.rotation = 0;
                data.categoryAxis.maxDivisions = 12;
                data.valueAxis.max = null;
                data.valueAxis.majorUnit = null;
                data.setId = chartId;
                data.nextIndex++;
                chart.noDataFound = data.series.length === 0;
                chart.chartOptions = data;
                chart.toolTipSuffix = "L";
               

                chart.seriesLabels.format = "{0}";
                chart.toolTipSuffix = "";
                chart.chartOptions.valueAxis.labels.format = "{0}";
                chart.chartDatamani();

                let gridData: any[] = this.results[chartIndex].gridData;
                let fields = this.results[chartIndex].fields;
                let benchmarkFields = this.results[chartIndex].benchmarkFields;
                gridData = Object.assign([], gridData);
                if (consumptionsArray && !consumptionsArray.isBenchmark) {
                    consumptionsArray.consumptionList.forEach((element) => {
                        let res2 = element.list;
                        let multiName = '';
                        let elementId = '';
                        multiName = element.name;
                        elementId = element.id;
                        if (res2.length == 0) {
                            multiName = 'EVALUATION.NO_DATA'
                            elementId = 'nodata';
                        }

                        fields.push(
                            { 'field': `column_filter_${filterTableCount + 1}_${elementId}_consumptions`, 'title': 'CONSUMPTION.CONSUMPTION_PER_PATIENT_DAY_LITRES', 'group': `${this.data.consumptionFilterList && this.data.consumptionFilterList[filterTableCount] ? this.data.consumptionFilterList[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}`, multiName: multiName },
                            { 'field': `column_filter_${filterTableCount + 1}_${elementId}_desinfection`, 'title': 'CONSUMPTION.HAND_DESINFECTIONS_PER_PATIENT', 'group': `${this.data.consumptionFilterList && this.data.consumptionFilterList[filterTableCount] ? this.data.consumptionFilterList[filterTableCount].filterName : this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (filterTableCount + 1)}`, multiName: multiName },
                        );

                        res2.forEach((item, i) => {
                            if (gridData.length == 0) {
                                var row = {};
                                row[`name`] = this.layoutService.translateText('CONFIGURE.YEAR');
                                row[`column_filter_${filterTableCount + 1}_${elementId}_consumptions`] = item.consumptionsPatientDay === -1 ? 0 : item.consumptionsPatientDay.toFixed(MAX_DECIMALS);
                                row[`column_filter_${filterTableCount + 1}_${elementId}_desinfection`] = item.desinfectionPatientDay === -1 ? 0 : item.desinfectionPatientDay.toFixed(MAX_DECIMALS);
                                gridData.push(row);
                            } else {
                                gridData[0][`column_filter_${filterTableCount + 1}_${elementId}_consumptions`] = item.consumptionsPatientDay === -1 ? 0 : item.consumptionsPatientDay.toFixed(MAX_DECIMALS);
                                gridData[0][`column_filter_${filterTableCount + 1}_${elementId}_desinfection`] = item.desinfectionPatientDay === -1 ? 0 : item.desinfectionPatientDay.toFixed(MAX_DECIMALS);
                            }
                        });
                    });
                } else if (consumptionsArray && consumptionsArray.isBenchmark) {
                    consumptionsArray.consumptionList.forEach((element) => {
                        let res2 = element.list;
                        let multiName = '';
                        let elementId = '';
                        multiName = element.name;
                        elementId = element.id;
                        if (res2.length == 0) {
                            multiName = 'EVALUATION.NO_DATA'
                            elementId = 'nodata';
                        }

                        benchmarkFields.push(
                            { 'field': `column_benchmark_${benchmarkTableCount + 1}_${elementId}_consumptions`, 'title': 'CONSUMPTION.CONSUMPTION_PER_PATIENT_DAY_LITRES', 'group': `${this.data.consumptionFilterList && this.data.consumptionFilterList[benchmarkTableCount] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.consumptionFilterList[benchmarkTableCount].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkTableCount + 1)}`, multiName: multiName },
                            { 'field': `column_benchmark_${benchmarkTableCount + 1}_${elementId}_desinfection`, 'title': 'CONSUMPTION.HAND_DESINFECTIONS_PER_PATIENT', 'group': `${this.data.consumptionFilterList && this.data.consumptionFilterList[benchmarkTableCount] ? this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' + this.data.consumptionFilterList[benchmarkTableCount].filterName : this.layoutService.translateText("EVALUATION.BENCHMARK") + ': ' +this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (benchmarkTableCount + 1)}`, multiName: multiName },
                        );

                        res2.forEach((item, i) => {
                            if (gridData.length == 0) {
                                var row = {};
                                row[`name`] = this.layoutService.translateText('CONFIGURE.YEAR');
                                row[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_consumptions`] = item.consumptionsPatientDay === -1 ? 0 : item.consumptionsPatientDay.toFixed(MAX_DECIMALS);
                                row[`column_benchmark_${benchmarkTableCount + 1}_${elementId}_desinfection`] = item.desinfectionPatientDay === -1 ? 0 : item.desinfectionPatientDay.toFixed(MAX_DECIMALS);
                                gridData.push(row);
                            } else {
                                gridData[0][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_consumptions`] = item.consumptionsPatientDay === -1 ? 0 : item.consumptionsPatientDay.toFixed(MAX_DECIMALS);
                                gridData[0][`column_benchmark_${benchmarkTableCount + 1}_${elementId}_desinfection`] = item.desinfectionPatientDay === -1 ? 0 : item.desinfectionPatientDay.toFixed(MAX_DECIMALS);
                            }
                        });
                    });
                }

                if (consumptionsArray.isBenchmark) {
                    benchmarkTableCount += 1;
                } else {
                    filterTableCount += 1;
                }

                this.results[chartIndex].gridData = gridData;
                this.results[chartIndex].fields = fields;
                this.results[chartIndex].benchmarkFields = benchmarkFields;
                this.results[chartIndex].resultChart = chart;

                setTimeout(() => {
                                    
                    this.compliance.setComplianceFields(this.results[chartIndex], 6, 2);
                    this.compliance.setFilters(this.filters.toArray());
        
                    if (index == res.length - 1) {
                        this.compliance.resultsLoader.next(cloneDeep(this.results));
                        this.charts.forEach((chart) => {
                            chart.chartOptions.valueAxis.title = {
                                text: this.layoutService.translateText(this.textLegendTxt),
                                font: "9px OpenSans-Regular"
                            }
    
                            chart.chartOptions.valueAxis.max = null;
                            chart.chartDatamani();
                        });
                        if (this.export) {
                            this.export.results = Object.assign([], this.results);
                        }
                    }
        
                }, 500);
            });

            this.evaluationLoaded = true;
            setTimeout(() => { this.initializeFilters(); }, 1000);

        }, 1000);

    }


    resetExportAs(value: 'image' | 'excel' | 'pdf') {
        switch (value) {
            case 'image':
                this.clickImageBtn = false;
                break;
            case 'excel':
                this.clickExcelBtn = false;
                break;
            case 'pdf':
                this.clickPdfBtn = false;
                break;
        }
    }

    emitData(event) {
        switch (event.key) {
            case 'totalConsumption': this.router.navigate(['evaluation/consumption/totalConsumption']); break;
            case 'consumptionPerPatient': this.router.navigate(['evaluation/consumption/consumptionPerPatient']); break;
            default: this.router.navigate(['evaluation/consumption/statistical']); break;
        }
    }

    onFilterRemoved() {
        this.compareCard = false;
        this.showCompareCard = false;
        this.compliance.showCompareCard = false;
        if (this.userHasFilter) {
            this.layoutService.showLoader = true;
            setTimeout(() => { this.evaluate(true); }, 1000);
        }
    }

    initializeFilters() {
        this.selectedSeries = [];
        this.filters.forEach((filter, index) => {
            filter.visible = true;
        });
        this.evaluationService.getSOPEvaluationSeries(this.userData.userId, "consumptionPatient").subscribe((seriesData: any) => {
            if (!seriesData || seriesData.selectedSeries == null) {
                this.layoutService.showLoader = false;
                return;
            }
            let chartSeries = JSON.parse(seriesData.selectedSeries);

            setTimeout(() => {
                chartSeries.forEach(serie => {
                  if(typeof serie === 'number'){
                      this.charts.forEach((chart) => {
                        this.compliance.toggleVisibility(chart.chartId, {index: serie });
                        chart.internalToggleSerie({ index: serie });
                      });
                  }else{
                    let chart = this.charts.find(c => c.chartId === serie.chartId);
                    if(!chart) return;
                    serie.series.forEach((serie) => {
                      chart.internalToggleSerie({ index: serie });
                      this.compliance.toggleVisibility(chart.chartId, {index: serie });
                    });
                    this.filters.forEach((filter, index) => {
                      if (index != serie.series) return;
                      if (filter.visible == undefined) filter.visible = true;
                      filter.visible = !filter.visible;
                    });
                  }
                });
                this.layoutService.showLoader = false;
            }, 1500);
        }, (error) => {
        });
    }

    changeLangProcessPage() {
        this.gridData.forEach((value, index) => {
            if (this.gridData[index].title)
                this.gridData[index].title = this.layoutService.translateText(value.title);
            if (this.gridData[index].nameFilter1)
                this.gridData[index].nameFilter1 = this.translatePeriods(value.nameFilter1);;//this.periodNames[value.nameFilter1];
        });
    }

    translatePeriods(period) {
        var returnPeriod;
        switch (period) {
            case 'January': returnPeriod = this.layoutService.translateText("CONSUMPTION.JANUARY"); break;
            case 'February': returnPeriod = this.layoutService.translateText("CONSUMPTION.FEBRUARY"); break;
            case 'March': returnPeriod = this.layoutService.translateText("CONSUMPTION.MARCH"); break;
            case 'April': returnPeriod = this.layoutService.translateText("CONSUMPTION.APRIL"); break;
            case 'May': returnPeriod = this.layoutService.translateText("CONSUMPTION.MAY"); break;
            case 'June': returnPeriod = this.layoutService.translateText("CONSUMPTION.JUNE"); break;
            case 'July': returnPeriod = this.layoutService.translateText("CONSUMPTION.JULY"); break;
            case 'August': returnPeriod = this.layoutService.translateText("CONSUMPTION.AUGUST"); break;
            case 'September': returnPeriod = this.layoutService.translateText("CONSUMPTION.SEPTEMBER"); break;
            case 'October': returnPeriod = this.layoutService.translateText("CONSUMPTION.OCTOBER"); break;
            case 'November': returnPeriod = this.layoutService.translateText("CONSUMPTION.NOVEMBER"); break;
            case 'December': returnPeriod = this.layoutService.translateText("CONSUMPTION.DECEMBER"); break;
            case 'Quarter1': returnPeriod = this.layoutService.translateText('CONFIGURE.QUARTER') + ' 1'; break;
            case 'Quarter2': returnPeriod = this.layoutService.translateText('CONFIGURE.QUARTER') + ' 2'; break;
            case 'Quarter3': returnPeriod = this.layoutService.translateText('CONFIGURE.QUARTER') + ' 3'; break;
            case 'Quarter4': returnPeriod = this.layoutService.translateText('CONFIGURE.QUARTER') + ' 4'; break;
            case 'Year': returnPeriod = this.layoutService.translateText('CONFIGURE.YEAR'); break;
        }
        return returnPeriod;
    }

    cancelFilter() {
        this.singleCard = false;
        this.compareCard = false;
    }

    exportAs() {
        this.clickImageBtn = true;
    }

    excelDownload() {
        this.clickExcelBtn = true;
    }

    downloadKendoPDF() {
        this.clickPdfBtn = true;
    }

    resetFilters() {
        this.filterDetails = [this.filterDetails[0]];
        this.filterIndices = [0];
        this.filters.toArray()[0].resetFilter();
        this.layoutService.showLoader = true;
        this.showCompareCard = false;
        var seriesData = {
            userId: this.userID,
            complianceType: "consumptionPatient",
            selectedSeries: null
        };

        this.evaluationService.updateSOPEvaluationSeries(seriesData).subscribe(() => { 
            setTimeout(() => { this.evaluate(true); }, 1500);
        }, () => { }, () => { });    }

    originalFields: any[] = null;
    selectedSeries: any[] = [];

    onSeriesClick(serie: any, resultIndex: number) {
        let chart = this.charts.find( c => c.chartId == serie.chartId);
        chart.series.get(serie.index).options.visible = serie.visible;

        this.filters.forEach((filter, index) => {
            if (index != serie.index) return;
            if (filter.visible == undefined) filter.visible = true;
            filter.visible = !filter.visible;
        });
    
        this.compliance.toggleVisibility(serie.chartId,serie);
    
        let visibilitySeries = [];
    
        this.charts.forEach((chart) => {
            let c = {
                chartId: chart.chartId,
                series: chart.series.map((s, index) => ({ series: s, index }))
                                    .filter(s => s.series.options.visible === false)
                                    .map(s => s.index)
            }
            visibilitySeries.push(c);
        })

        var seriesData = {
            userId: this.userID,
            complianceType: "consumptionPatient",
            selectedSeries: JSON.stringify(visibilitySeries)
        };

        this.evaluationService.updateSOPEvaluationSeries(seriesData).subscribe(() => { }, () => { }, () => { });
    }

    onFilterSaved() {
        // Buscar nombres duplicados y renombrar los duplicados
        const renamedFilters: string[] = [];
        var filters = this.filters.toArray();
        // Recorre desde el último hasta el primero
        for (let i = filters.length - 1; i >= 0; i--) {
        const currentName = filters[i].filterName?.trim() || '';
        for (let j = 0; j < filters.length; j++) {
            if (i !== j && currentName && currentName === (filters[j].filterName?.trim() || '')) {
            // Si hay coincidencia, renombra el actual
            const translatedFilterName = this.layoutService.translateText('EVALUATION.FILTER') + ' ' + (i + 1);
            filters[i].filterName = translatedFilterName;
            filters[i].setFilterName = translatedFilterName;          
            renamedFilters.push(translatedFilterName);
            break;
            }
        }
        }

        if (renamedFilters.length > 0) {
            const f = renamedFilters[renamedFilters.length - 1];
            const msg = `${this.layoutService.translateText('EVALUATION.FILTER_DUPLICATED_NAME')} '${f}'.`;
            this.layoutService.showWarning(msg);
        }
        this.evaluate(true);
    }

    onRefreshClick(noDataFound: boolean) {
        if (noDataFound) {
            return;
        }

        this.evaluate(true);
    }

    trackLoop(index: number, item: any) {
        return item;
    }
}
